import { IonModal, IonContent, IonAccordionGroup, IonCard, IonGrid,IonRow,IonCol, IonLabel,IonInput,IonIcon } from '@ionic/react'
import {useState, useEffect} from "react";
import { AutoComplete,  } from 'antd';
import { getAddressSuggestions} from "../services/apiService"  
import { validateAddressBody } from "../services/validators"
import { useSetRecoilState } from "recoil";
import { oldBookingState } from "../../../store/atoms"
import { handleDeleteBooking } from "../services/handlers"
import 'antd/dist/antd.min.css';

function InputAddressComponent (props) {

    const [showEditOption , setShowEditOption] = useState(null)
    const [suggestedAddress , setSuggestedAddress] = useState([])
   const [displayTitle , setDisplayTitle] = useState(false)
   const [selectedAddress , setSelectedAddress] = useState({})
   const setOldBooking = useSetRecoilState(oldBookingState)

    useEffect(()=>{ 
        if (props.addressType === 'pickUpLocation') {
            if(props.deliveryAddresses.pickUpLocation) {
              setSelectedAddress({
                postalCode: props.deliveryAddresses.pickUpLocation.postalCode,
                address:  props.deliveryAddresses.pickUpLocation.address,
                floor:  props.deliveryAddresses.pickUpLocation.floor,
                unitNumber:  props.deliveryAddresses.pickUpLocation.unitNumber,
                contactName:  props.deliveryAddresses.pickUpLocation.contactName,
                latitude:props.deliveryAddresses.pickUpLocation.latitude,
                longitude:props.deliveryAddresses.pickUpLocation.longitude,
                contactNumber:  props.deliveryAddresses.pickUpLocation.contactNumber,
                showEdit:true
              })
              setShowEditOption(props.deliveryAddresses[props.addressType].showEdit)
            }
        }
    
        if (props.addressType === 'dropOffLocation') {
          if(props.deliveryAddresses.dropOffLocation) {
            setSelectedAddress({
              postalCode: props.deliveryAddresses.dropOffLocation.postalCode,
              address:  props.deliveryAddresses.dropOffLocation.address,
              floor:  props.deliveryAddresses.dropOffLocation.floor,
              unitNumber:  props.deliveryAddresses.dropOffLocation.unitNumber,
              contactName:  props.deliveryAddresses.dropOffLocation.contactName,
              contactNumber:  props.deliveryAddresses.dropOffLocation.contactNumber,
                latitude:props.deliveryAddresses.dropOffLocation.latitude,
                longitude:props.deliveryAddresses.dropOffLocation.longitude,
              showEdit:true
            })
          }
          setShowEditOption(props.deliveryAddresses[props.addressType].showEdit)
        }
    
        if (props.addressType === 'additionalStops') {
          if( props.deliveryAddresses.additionalStops[props.stopNumber]  ) { //props.stopNumber <= props.deliveryAddresses.additionalStops.length-1
            setSelectedAddress({
              postalCode: props.deliveryAddresses.additionalStops[props.stopNumber].postalCode,
              address:  props.deliveryAddresses.additionalStops[props.stopNumber].address,
              floor:  props.deliveryAddresses.additionalStops[props.stopNumber].floor,
              unitNumber:  props.deliveryAddresses.additionalStops[props.stopNumber].unitNumber,
              contactName:  props.deliveryAddresses.additionalStops[props.stopNumber].contactName,
              contactNumber:  props.deliveryAddresses.additionalStops[props.stopNumber].contactNumber,
              showEdit:true,
              latitude:props.deliveryAddresses.additionalStops[props.stopNumber].latitude,
              longitude:props.deliveryAddresses.additionalStops[props.stopNumber].longitude,
            })
            setShowEditOption(props.deliveryAddresses.additionalStops[props.stopNumber].showEdit)
          }
        }

  
    },[JSON.stringify(props.deliveryAddresses), JSON.stringify(props.deliveryAddresses.additionalStops)])

    const handleSuggestAddress = async (value) => {
        if(!value) {
          setSuggestedAddress([])
        }
        setSuggestedAddress([])
        let res = await getAddressSuggestions(value)
    
        let suggestedAddress = []
    
        for (let native of res.data.native) {
            if (native.subLocations && native.subLocations.length > 0) {
    
                for (let sublocation of native.subLocations) {
                  suggestedAddress.push({
                      name : `${native.name} - ${sublocation.name}`,
                      postalCode : sublocation.postalCode ? sublocation.postalCode : "",
                      latitude : sublocation.latitude ? sublocation.latitude : "",
                      longitude : sublocation.longitude ? sublocation.longitude : "" ,
                    value: `${native.name} ${sublocation.name}`,
                    label:`${native.name} ${sublocation.name}`,
                  })
                }
    
            } else {
              suggestedAddress.push({
                  name : native.name ,
                  postalCode : native.postalCode ? native.postalCode : "",
                  latitude : native.latitude? native.latitude : "",
                  longitude : native.longitude ? native.longitude : "",
                value:`${native.name} ${native.address}`,
                label:`${native.name} ${native.address}`,
              })
            }
        } 
    
        for (let location of res.data.location) {
          suggestedAddress.push({
              name: location.address,
              postalCode : location.postalCode ? location.postalCode : "",
              latitude : location.latitude? location.latitude : "",
              longitude : location.longitude ? location.longitude : "",
              value : `${location.name} ${location.address}`,
              label : `${location.name} ${location.address}`,
              key: `${location.name} ${location.address}`
          })
        }
    
    
    
        setSuggestedAddress(suggestedAddress)
       }
    
    const handleAddressInput = async (type , value) => {
        let updatedAddress = {...selectedAddress}
        updatedAddress[`${type}`] = value
        setSelectedAddress(updatedAddress)

        let currentDeliveryAddressess = {...props.deliveryAddresses}

        if (props.addressType === 'pickUpLocation') {

          currentDeliveryAddressess.pickUpLocation = updatedAddress
          let validationResult = props.validation(props.addressType, type, value)
          if (validationResult.validationStatus ) {
            if(!currentDeliveryAddressess.validationPassed && currentDeliveryAddressess.issueAddressType === props.addressType && 
                                    currentDeliveryAddressess.issueInputType === type) {
                                    props.setDeliveryAdderss({...currentDeliveryAddressess, errorMessage: "",
                                            validationPassed : true, issueAddressType: "", issueInputType: ""}
                                            )
                            sessionStorage.setItem("oldAddress", JSON.stringify({...currentDeliveryAddressess, errorMessage: "",
            validationPassed : true}))
            return
          }
          

        }

        } else if (props.addressType === 'dropOffLocation') {

          currentDeliveryAddressess.dropOffLocation = updatedAddress
          currentDeliveryAddressess.calculateTripFare = true
          let validationResult = props.validation(props.addressType, type, value)
        if (validationResult.validationStatus ) {

          if(!currentDeliveryAddressess.validationPassed && currentDeliveryAddressess.issueAddressType === props.addressType && 
            currentDeliveryAddressess.issueInputType === type) {
              props.setDeliveryAdderss({...currentDeliveryAddressess, errorMessage: "",
                    validationPassed : true, issueAddressType: "", issueInputType: ""})
            sessionStorage.setItem("oldAddress", JSON.stringify({...currentDeliveryAddressess, errorMessage: "",
            validationPassed : true}))
            return
          }
          

        }

        } else {

          currentDeliveryAddressess.additionalStops[props.stopNumber] = updatedAddress
          
          let validationResult = props.validation(props.addressType, type, value)
        if (validationResult.validationStatus ) {

          if(!currentDeliveryAddressess.validationPassed && currentDeliveryAddressess.issueAddressType === props.addressType && 
            currentDeliveryAddressess.issueInputType === type && currentDeliveryAddressess.issueAdditionalStopIndex === props.stopNumber) {

              props.setDeliveryAdderss({...currentDeliveryAddressess, errorMessage: "",
                    validationPassed : true, issueAddressType: "", issueInputType: ""})
            sessionStorage.setItem("oldAddress", JSON.stringify({...currentDeliveryAddressess, errorMessage: "",
            validationPassed : true}))
            return

          }
          

        }

        }

        props.setDeliveryAdderss({...currentDeliveryAddressess, errorMessage: "",
        validationPassed : true})
        sessionStorage.setItem("oldAddress", JSON.stringify({...currentDeliveryAddressess, errorMessage: "",
        validationPassed : true}))
        return
        
        


        
     }  
    
    const onSelectAddress = async (value) => {
        let address ;
          for( let selectedAddress of suggestedAddress) {
    
              if (selectedAddress.value === value) {
                address = selectedAddress
              }
          }
          
          setSelectedAddress({...selectedAddress, postalCode: address.postalCode, address: address.value,latitude:address.latitude,
            longitude:address.longitude,  floor:"", unitNumber:"",contactName:"",contactNumber:""})
          
          let currentDeliveryAddressess = {...props.deliveryAddresses}
          if (props.addressType === 'pickUpLocation') {

            currentDeliveryAddressess.pickUpLocation = {...selectedAddress, postalCode: address.postalCode, address: address.value,latitude:address.latitude,
              longitude:address.longitude,  floor:"", unitNumber:"",contactName:"",contactNumber:"", showEdit:true}

          } else if (props.addressType === 'dropOffLocation') {

            currentDeliveryAddressess.dropOffLocation = {...selectedAddress, postalCode: address.postalCode, address: address.value,latitude:address.latitude,
              longitude:address.longitude,  floor:"", unitNumber:"",contactName:"",contactNumber:"",  showEdit:true}

          } else {

            currentDeliveryAddressess.additionalStops[props.stopNumber] = {...selectedAddress, postalCode: address.postalCode, address: address.value,latitude:address.latitude,
              longitude:address.longitude,  floor:"", unitNumber:"",contactName:"",contactNumber:"", showEdit:true}

          }
          currentDeliveryAddressess.calculateTripFare = true
          
          // props.setDeliveryAdderss(currentDeliveryAddressess)

          let validationResult = props.validation(props.addressType, "address", [address.latitude, address.longitude])
          if (validationResult.validationStatus ) {
            props.setDeliveryAdderss({...currentDeliveryAddressess , errorMessage: "",
            validationPassed : true})
            //Store the booking atom here
            //setOldBooking({...currentDeliveryAddressess , errorMessage: "", validationPassed : true})
            if (props.addressType !== 'pickUpLocation') {
              props.setDeliveryAdderss({...currentDeliveryAddressess , goToPayment:true})
              sessionStorage.setItem("oldAddress", JSON.stringify({...currentDeliveryAddressess , goToPayment:true}))
            }
          } else {
            props.setDeliveryAdderss({...currentDeliveryAddressess , errorMessage: validationResult.errorMessage,
            validationPassed : validationResult.validationStatus, goToPayment:false})
            sessionStorage.setItem("oldAddress", JSON.stringify({...currentDeliveryAddressess , errorMessage: validationResult.errorMessage,
              validationPassed : validationResult.validationStatus, goToPayment:false}))
          }
    
    
        }

    return (
        <>
        { showEditOption &&
        <div className='deactive' key={props.key ? props.key : props.addressType}>
           <IonGrid>
              <IonRow>
              <IonCol>
                  <h4>{props.title}</h4>
                </IonCol>
              </IonRow>
               <IonRow>
                
                   <IonCol size="6">
                   <h6>Search Address*</h6>
                    <AutoComplete
                                        options={suggestedAddress}
                                        onSelect={onSelectAddress}
                                        onSearch={handleSuggestAddress}
                                        defaultValue={selectedAddress.address}
                                        style={{height: "50px", width: "350px" }}
                                        
                                      >
                                </AutoComplete></IonCol>
                   <IonCol><h6>Floor*</h6><input type="text"        value={selectedAddress.floor} onChange={(e)=>handleAddressInput("floor", e.target.value)}/></IonCol>
                   <IonCol><h6>Unit Number*</h6><input type="text"  value={selectedAddress.unitNumber} onChange={(e)=>handleAddressInput("unitNumber", e.target.value)}/></IonCol>
               </IonRow>
               <IonRow>
                  
                   <IonCol><h6>Contact Name*</h6><input type="text" value={selectedAddress.contactName} onChange={(e)=>handleAddressInput("contactName", e.target.value)}/></IonCol>
                   <IonCol><h6>Contact Number*</h6><input type="text"  value={selectedAddress.contactNumber} onChange={(e)=>handleAddressInput("contactNumber", e.target.value)} /></IonCol>
               </IonRow>

           </IonGrid>
       </div>
}
{ !showEditOption &&
       <div className='active'>
       <h4 className='selected-address' onClick={()=>{
        setShowEditOption(true)

        let currentDeliveryAddress = {...props.deliveryAddresses}
        let deliveryPoints = ['pickUpLocation', 'dropOffLocation', 'additionalStops']

        

          if (props.addressType === 'pickUpLocation') {

            
            
            currentDeliveryAddress.pickUpLocation.showEdit = true
            currentDeliveryAddress.dropOffLocation.showEdit = false
            for ( let stop of currentDeliveryAddress.additionalStops) {
              stop.showEdit = false
            }
            
          }

          if (props.addressType === 'dropOffLocation') {

            
            
            currentDeliveryAddress.pickUpLocation.showEdit = false
            currentDeliveryAddress.dropOffLocation.showEdit = true
            for ( let stop of currentDeliveryAddress.additionalStops) {
              stop.showEdit = false
            }
            
          }

          if (props.addressType === 'additionalStops') {



            currentDeliveryAddress.pickUpLocation.showEdit = false
            currentDeliveryAddress.dropOffLocation.showEdit = false
            for ( let i=0; i < currentDeliveryAddress.additionalStops.length ; i++) {
              
              if (i !== props.stopNumber) {
                currentDeliveryAddress.additionalStops[i] = {...currentDeliveryAddress.additionalStops[i] , showEdit: false}
              } else {
                currentDeliveryAddress.additionalStops[i] = {...currentDeliveryAddress.additionalStops[i] , showEdit: true}
              } 
            }
            
          }
        

        
        props.setDeliveryAdderss({...currentDeliveryAddress})
         
        }}>{selectedAddress.address ? selectedAddress.address  : props.title}</h4>
       {selectedAddress.address ?<p> Unit : #{selectedAddress.floor}-{selectedAddress.unitNumber}   |   Contact : {selectedAddress.contactName}   |   Number : {selectedAddress.contactNumber} </p> : <p></p> }
       <button className='outline'><img alt="img edit" src="img/edit.svg" onClick={()=>{
        setShowEditOption(true)

        let currentDeliveryAddress = {...props.deliveryAddresses}
        let deliveryPoints = ['pickUpLocation', 'dropOffLocation', 'additionalStops']

        

          if (props.addressType === 'pickUpLocation') {

            
            
            currentDeliveryAddress.pickUpLocation.showEdit = true
            currentDeliveryAddress.dropOffLocation.showEdit = false
            for ( let stop of currentDeliveryAddress.additionalStops) {
              stop.showEdit = false
            }
            
          }

          if (props.addressType === 'dropOffLocation') {

            
            
            currentDeliveryAddress.pickUpLocation.showEdit = false
            currentDeliveryAddress.dropOffLocation.showEdit = true
            for ( let stop of currentDeliveryAddress.additionalStops) {
              stop.showEdit = false
            }
            
          }

          if (props.addressType === 'additionalStops') {



            currentDeliveryAddress.pickUpLocation.showEdit = false
            currentDeliveryAddress.dropOffLocation.showEdit = false
            for ( let i=0; i < currentDeliveryAddress.additionalStops.length ; i++) {
              
              if (i !== props.stopNumber) {
                currentDeliveryAddress.additionalStops[i] = {...currentDeliveryAddress.additionalStops[i] , showEdit: false}
              } else {
                currentDeliveryAddress.additionalStops[i] = {...currentDeliveryAddress.additionalStops[i] , showEdit: true}
              } 
            }
            
          }
        

        
        props.setDeliveryAdderss(currentDeliveryAddress)
         
        }}/></button> 
       <button className='outline delete'><img alt="trash" src="img/trash.svg" onClick={()=>{
            handleDeleteBooking(props.deliveryAddresses,props.setDeliveryAdderss, props.addressType, props.stopNumber)
       }}
       
       
       
       /></button> 
       </div>
}
</>
    )
}

export default InputAddressComponent;